import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { jwtDecode } from "jwt-decode";

const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    // auth-service returns to /#/auth/callback?token=…; urlCleanup.hashToPath has already moved
    // the token into the query string by the time this runs.
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token) {
      try {
        localStorage.setItem("jwtToken", token);
        const decoded = jwtDecode(token);

        setUser({
          email: decoded.sub,
          role: decoded.role,
          companyId: decoded.companyId,
        });

        navigate("/dashboard", { replace: true });
      } catch (err) {
        console.error("Failed to decode token:", err);
        navigate("/login", { replace: true });
      }
    } else {
      navigate("/login", { replace: true });
    }
  }, [navigate, setUser]);

  return <p>Finishing login...</p>;
};

export default AuthCallbackPage;
